<template>
   <div>
<!--     {{samples}}-->
     <i v-if="table_message !== null">{{ table_message }}</i>
     <v-card-actions>
       <DoneTypingSearch
           ref="search_field"
           v-model="controls.specialSearch"
           @done="controls.search = $event"
           @enter="onSearch"
           class="mr-2"
           label="Search Table"
           :loading="controls.loadingSearch"
           :disabled="controls.loadingSearch"
       >
       </DoneTypingSearch>
       <MasterQuery @query="loadSamples($event)">
         <template  v-slot:activator>
           <v-tooltip bottom>
             <template v-slot:activator="{on}">
               <v-btn v-on="on" class="mt-5" @click="loadSamples()" small outlined><v-icon>refresh</v-icon></v-btn>
             </template>
             <span>Re-run query</span>
           </v-tooltip>
         </template>
       </MasterQuery>
       <v-spacer></v-spacer>
       <v-spacer></v-spacer>
       <v-btn-toggle v-if="!controls.loadingTestTypes && !disabled_headers" label>
         <v-btn @click="reload" small>
           <v-icon >mdi-refresh</v-icon>
         </v-btn>
         <v-menu class="overflow-auto" offset-y :close-on-content-click="false" nudge-width="200">
           <template v-slot:activator="{on}">
             <v-btn v-on="on" small>
               <v-icon>mdi-table-column</v-icon>
             </v-btn>
           </template>
           <v-card class="pa-0 overflow-y"  style="max-height: 500px">
             <v-card-text class="pa-0">
               <v-list >
                 <v-list-item v-for="header in controls.tableHeaders" :key="header.value">
                   <v-list-item-content class="pt-1 pb-1">
                     <v-list-item-title class="pt-1 pb-1">
                       <v-checkbox class="ma-0 pa-0" :label="header.text" v-model="header.show" dense>
                       </v-checkbox >
                     </v-list-item-title>
                   </v-list-item-content>
                 </v-list-item>
               </v-list>
             </v-card-text>
           </v-card>
         </v-menu>
       </v-btn-toggle>
     </v-card-actions>
     <template v-if="controls.loadingNextSet">
       <v-progress-linear indeterminate></v-progress-linear>
     </template>
     <v-data-table
         id="data_table"
         :headers="tableHeaders"
         :items="samplesLimited"
         sort-desc
         sort-by="id"
         item-key="uuid"
         v-scroll:#data_table="onScroll"
         single-expand
         :expanded.sync="controls.expandedItem"
         disable-pagination
         hide-default-footer
         hide-default-header
         show-expand
         dense
     >
      <template v-slot:header="prop">
<!--        <tr>-->
        <SampleTrackingTableHeader :headers="prop.props.headers" @query="loadHeaderQuery($event)" :loading="controls.loading"></SampleTrackingTableHeader>
<!--        </tr>-->
      </template>
       <template
           v-if="virtualScroll.start > 0"
           v-slot:body.prepend
       >
         <tr>
           <td
               :colspan="tableHeaders.length"
               :style="'padding-top:'+startHeight+'px'"
           >
           </td>
         </tr>
       </template>
       <template
           v-if="(virtualScroll.start + virtualScroll.perPage) < samples.length"
           v-slot:body.append
       >
         <tr>
           <td
               :colspan="tableHeaders.length"
               :style="'padding-top:'+endHeight+'px'"
           >
           </td>
         </tr>
       </template>
      <template v-slot:item.data-table-expand="{item, expand, isExpanded}">
        <td @click="goToExpandedRow(expand, isExpanded)">
          <SampleContextMenu :sample="{id: item.id, customer_id: item.customer_id}">
            <template v-slot:activator="{show}">
              <v-list-item @contextmenu="show" :ref="item.id" link  :class="isExpanded ? 'primary darken-2' : ''" class="">
                <v-badge v-if="item.is_released" color="success" icon="mdi-check" right tile inline>
                  <template v-slot:badge>
                    <v-icon x-small>mdi-check</v-icon> Released
                  </template>
                  <div :class="isExpanded ? 'white--text' : ''">{{item.id}}</div>
                </v-badge>
                <v-badge v-else-if="item.qa_approved" color="purple" icon="mdi-check" right tile inline>
                  <template v-slot:badge>
                    <v-icon x-small>mdi-check</v-icon> Approved
                  </template>
                  <div :class="isExpanded ? 'white--text' : ''">{{item.id}}</div>
                </v-badge>
                <v-badge v-else-if="$moment().diff($moment(item.created_at), 'days') > 3" color="error" right tile inline>
                  <template v-slot:badge>
                    {{$moment().diff($moment(item.created_at), 'days')}} Aging
                  </template>
                  <div :class="isExpanded ? 'white--text' : ''">{{item.id}}</div>
                </v-badge>
                <div v-else :class="isExpanded ? 'white--text' : ''">{{item.id}}</div>
              </v-list-item>
            </template>
          </SampleContextMenu>
        </td>
      </template>
       <template v-slot:item.uuid="{item}">
         <td style="width: 1%; white-space:nowrap">
           <RequiredTests :sample="item" show_count chips></RequiredTests>
         </td>
       </template>
       <template v-slot:item.sample_flags="{item}">
         <v-tooltip color="grey darken-3" bottom>
           <template v-slot:activator="{on}">
             <v-chip v-on="on" color="primary" class="white--text"  small label>{{item.sample_notes.length}} notes</v-chip>
           </template>
           <template v-if="item.sample_notes.length > 0" v-for="(note, index) in item.sample_notes">
             <span :key="note.uuid">({{note.note_type.name}}) - {{note.note}}</span>
             <v-divider class="grey" :key="index"></v-divider>
           </template>
           <span v-else>No Notes</span>
         </v-tooltip>
         <template v-if="item.sample_flags.length > 0">
           <v-tooltip v-for="flag in item.sample_flags" :key="flag.uuid" color="grey darken-3" bottom>
             <template v-slot:activator="{on}">
               <v-chip v-on="on" :color="flag.flag_type.color" class="white--text"  small label>
                 <span v-if="flag.flag_type.name.split(' ').length > 1">{{flag.flag_type.name.split(' ').map(text => text[0]).join('')}}</span>
                 <span v-else>{{flag.flag_type.name.substring(0,3)}}</span>
               </v-chip>
             </template>
             <span>{{flag.flag_type.name}}</span>
           </v-tooltip>
         </template>
       </template>
       <template v-slot:expanded-item="{item, headers}">
         <td id="expanded_item" :colspan="headers.length">
           <slot name="expanded_item" :item="item">
           </slot>
         </td>
       </template>
     </v-data-table>
   </div>
</template>

<script>
export default {
  name: "SampleTrackingTable",
  components: {
    DoneTypingSearch: () => import("@/components/general/DoneTypingSearch"),
    SampleContextMenu: () => import("@/components/general/samples/SampleContextMenu"),
    RequiredTests: () => import("@/components/general/samples/RequiredTests"),
    MasterQuery: () => import("@/components/QueryBuilder/MasterQuery"),
    SampleTrackingTableHeader: () => import("@/components/general/samples/SampleTrackingTableHeader")
  },
  props: {
    table_message: {
      default: null,
    },
    add_where:{
      type: Array,
      default: () => ([])
    },
    disabled_headers:{
      default: null,
    }
  },
  data: () => ({
    virtualScroll:{
      start: 0,
      timeout: null,
      rowHeight: 55,
      perPage: 20,
    },
    controls:{
      page: 1,
      expandedItem: [],
      maxPages: 1,
      specialSearch: null,
      customQuery: null,
      headerQuery: null,
      search: null,
      loading: null,
      loadingSearch: false,
      loadingNextSet: false,
      tableHeaderWidths: false,
      tableHeaders : [
        {
          text: 'Sample id',
          value: 'data-table-expand',
          show: true,
          queryable: {type: 'text', key: 'id', value: null},
          class: 'sticky-header'
        },
        {
          text: 'Tests',
          value: 'uuid',
          sortable: false,
          show:true,
          queryable: {type: 'multi-select', model: 'sampleTestTypes',relation: 'sampleTests', value: []},
          class: 'sticky-header'
        },
        {
          text: 'Flags',
          value: 'sample_flags',
          sortable: false,
          show:true,
          queryable: {type: 'multi-select', model: 'sampleFlagTypes', relation: 'sampleFlags', value: []},
          class: 'sticky-header'
        },
        {
          text: 'Type',
          value: 'sample_cert_type.name',
          show: true,
          queryable: {type: 'multi-select', key: 'sample_cert_type_uuid', model: 'sampleCertTypes', value: []},
          class: 'sticky-header'
        },
        {
          text: 'Customer',
          value: 'customer.primary_name.name',
          show: true,
          queryable: {type: 'multi-select', key: "customer_id", model: 'names', value: []},
          class: 'sticky-header'
        },
        {
          text: "Name",
          value: "name",
          show: true,
          queryable: {type: "text", key: "name", value: null},
          class: 'sticky-header'
        },
        {
          text: "qa",
          value: "qa",
          show: true,
          queryable: { type: 'text', key: 'qa', value: null,},
          class: 'sticky-header'
        },
        {
          text: "lot",
          value: "lot",
          show: true,
          queryable: { type: 'text', key: 'lot', value: null,},
          class: 'sticky-header'
        },
        {
          text: "RND",
          value: "is_rnd",
          show: true,
          queryable: false,
          class: 'sticky-header'
        },
        {
          text: "Manifest ID",
          value: "manifest_id",
          queryable: {type: 'text', key: 'manifest_id', value: null},
          show: false,
          class: 'sticky-header'
        },
        {
          text: "Legal Type",
          value: "legal_type",
          queryable: {type: 'text', key: 'legal_type', value: null},
          show: false,
          class: 'sticky-header'
        },
        {
          text: "harvest_date",
          value: "harvest_date",
          queryable: false,
          show: false,
          class: 'sticky-header'
        },
        {
          text: "weight",
          value: "weight",
          show: false,
          queryable: false,
          class: 'sticky-header'
        },
        {
          text: "pieces",
          value: "pieces",
          show: false,
          queryable: false,
          class: 'sticky-header'
        },
        {
          text: "unit_uuid",
          value: "unit_uuid",
          show: false,
          queryable: false,
          class: 'sticky-header'
        },
        {
          text: "created_by",
          value: "created_by",
          show: false,
          queryable: false,
          class: 'sticky-header'
        },
        {
          text: "updated_by",
          value: "updated_by",
          show: false,
          queryable: false,
          class: 'sticky-header'
        },
        {
          text: "Created At",
          value: "created_at",
          show: true,
          queryable: false,
          class: 'sticky-header'
        },
        {
          text: "updated_at",
          value: "updated_at",
          show: false,
          queryable: false,
          class: 'sticky-header'
        }
      ]
    }
  }),
  watch:{
    samplesLimited(v, old){
      if(this.controls.expandedItem.length > 0){
        const expandedItem = this.controls.expandedItem[0]
        if(!v.find(item => expandedItem.uuid === item.uuid)){
          this.controls.expandedItem = [];
        }
      }
      if(v.length === 0 && old.length > 0 && this.samples.length > 0){
        this.virtualScroll.start = 0;
      }
    },
    add_where(){
      this.loadSamples();
    }
  },
  computed: {
      samplesLimited() {
        return [...this.samples.slice(this.virtualScroll.start, this.virtualScroll.perPage+this.virtualScroll.start)];
      },
      startHeight() {
        // let expandedRowHeight = 0;
        // let element = document.getElementById("expanded_item");
        // if(element){
        //   expandedRowHeight = element.clientHeight;
        // }
        return (this.virtualScroll.start * this.virtualScroll.rowHeight) - 170;
      },
      endHeight() {
        return (this.virtualScroll.rowHeight * (this.samples.length - this.virtualScroll.start));
      },
      tableHeaders(){
        return this.controls.tableHeaders.filter(header => header.show);
      },
      samples(){
        const samples = this.$store.$db().model('samples').query()
            .with('sample_cert_type')
            .with('sample_tests.test_type')
            .with('sample_notes.note_type')
            .with('sample_flags.flag_type')
            .with('customer')
            .orderBy('id', 'desc')
            .get();
        if(this.controls.search && this.controls.search !== '' && samples.length > 0){
          return samples.filter(item => this.customFilter(this.controls.search, item))
        }
        return samples
      }
  },
  mounted(){
    if(this.disabled_headers){
      this.controls.tableHeaders.forEach((header) => {
        if(this.disabled_headers.includes(header.text)){
          header.show = false;
        }
      })
    }
  },
  methods: {
    customFilter (search, item) {
      let stringed = JSON.stringify(item).toString().replace(/"/g, '').replace(/requirements:\[(\{.*\})\}\]/, '');
      return search != null &&
          stringed.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
      // return value != null &&
      //     search != null &&
      //     typeof value !== 'boolean' &&
      //     stringed.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
    },
    async loadHeaderQuery(query){
      this.controls.headerQuery = query
      this.controls.loading = true;
      await this.$store.$db().model('samples').deleteAll();
      await this.$store.$db().model('sampleTests').deleteAll();
      await this.$store.dispatch("showLoading", "Loading custom query");
      await this.$store.$db().model('samples').api().fetch(this.addToQuery(query))
      await this.$store.dispatch("resetLoading");
      this.controls.loading = false;
    },
    async loadSamples(customQuery = null){
      this.controls.loading = true;
      this.controls.headerQuery = null;
      await this.$store.$db().model('samples').deleteAll();
      await this.$store.$db().model('sampleTests').deleteAll();
      await this.$store.dispatch("showLoading", "Loading custom query");
      if(customQuery){
        this.controls.customQuery = customQuery;
        await customQuery.model.api().fetch(this.addToQuery(customQuery.raw.query))
      }else{
        await this.controls.customQuery.model.api().fetch(this.addToQuery(this.controls.customQuery.raw.query))
      }
      await this.$store.dispatch("resetLoading");
      this.controls.loading = false;
    },
    async onSearch(){
      if(this.controls.search === null || this.controls.search.length === 0) {
        this.loadSamples(); return;
      }
      if(this.controls.search.length < 3 || !/\d/.test(this.controls.search)) return;
      let nextPage = this.$store.state.entities['samples'].next_page;
      try{
        this.controls.loadingSearch = true
        await this.$store.$db().model('samples').api().fetch(this.addToQuery({
          where: [{
            key: `id`,
            condition: "~",
            value: this.$refs.search_field.regexQuery(this.controls.search)
          }]
        }))

      }catch(e){
        this.$store.dispatch("showError", "Failed to search sample")
      }finally{
        this.controls.loadingSearch = false
        this.$store.state.entities['samples'].next_page = nextPage;
      }
    },
    onScroll(value){
      // console.log('scrolling')
      // console.log('made it here', this.controls.search)
      if((!this.controls.search || this.controls.search === '') && !this.controls.loadingNextSet && ((value.target.scrollHeight - value.target.scrollTop) - value.target.clientHeight < 5)){
        this.loadNextSet().then(() => {
          this.setVirtualScroll(value);
        })
      }else{
        this.setVirtualScroll(value);
      }
    },
    setVirtualScroll(value){
      // console.log( (((value.target.scrollHeight - value.target.scrollTop) - this.endHeight) - 640) )
      // 640
      // if(!(this.samples.length <= this.virtualScroll.perPage) && ((value.target.scrollHeight - value.target.scrollTop) - this.endHeight) - 640 < 50){
      //   this.controls.expandedItem = [];
      // }
      if(this.samples.length <= this.virtualScroll.perPage || (this.controls.expandedItem.length > 0 && !(((value.target.scrollHeight - value.target.scrollTop) - this.endHeight) - 640  < 50))) return;
      this.virtualScroll.timeout && clearTimeout(this.virtualScroll.timeout);
      this.virtualScroll.timeout = setTimeout(() => {
        const { scrollTop } = value.target;
        const rows = Math.ceil(scrollTop / (this.virtualScroll.rowHeight));
        // console.log('rows', rows)
        // console.log('perpage', this.virtualScroll.perPage)
        // console.log('length', this.samples.length)
        // console.log('math', rows + this.virtualScroll.perPage)
        this.virtualScroll.start = rows + this.virtualScroll.perPage > this.samples.length ?
            this.samples.length - this.virtualScroll.perPage: rows;
        // console.log('start',this.virtualScroll.start)
        this.$nextTick(() => {
          value.target.scrollTop = scrollTop;
        });
      }, 20);
    },
    async loadNextSet(){
      if(this.controls.loading) return;
      if(this.controls.search && this.controls.search !== '')return;
      if(!this.$store.state.entities.samples.pagination.next_page) return;
      if(this.controls.customQuery){
        this.controls.loadingNextSet = true;
        if(this.controls.headerQuery){
          await this.$store.$db().model('samples').api().fetch(this.addToQuery(this.controls.headerQuery), "",null,true,true)
        }else{
          await this.$store.$db().model('samples').api().fetch(this.addToQuery(this.controls.customQuery.raw.query), "",null,true,true)
        }
        this.controls.loadingNextSet = false;
      }

    },
    async goToExpandedRow(expand, isExpanded){
      if(this.controls.expandedItem.length > 0 && !isExpanded){
        this.controls.expandedItem = []
      }
      this.$nextTick(()=> {
        expand(!isExpanded);
        if(!isExpanded){
          this.$nextTick(()=> {
            this.$vuetify.goTo("#expanded_item", {
              container: "#data_table"
            })
          })
        }
      })
    },
    reload(){
      window.location.reload();
    },
    addToQuery(query){
      if(this.add_where){
        if(query.where){
          query.where = [...query.where.filter(val => !this.add_where.some(where => where.key === val.key)), ...this.add_where]
        }else{
          query.where = this.add_where
        }
      }
      return {
        ...query,
        paginate: 20,
        with: 'sampleTests,sampleFlags,sampleNotes',
        order_by_desc: "id"
      }
    }
  },
  beforeDestroy(){
    this.$store.$db().model('samples').deleteAll();
    this.$store.$db().model('sampleTests').deleteAll();
    this.$store.$db().model('sampleFlags').deleteAll();
    this.$store.$db().model('sampleNotes').deleteAll();
  }
}
</script>

<style scoped>
#data_table {
  max-height: 65vh;
  overflow: auto;
}
</style>
